import { defaultHttpClient } from '../../httpClient';
import {
  atomicRendererDataConverter,
  type ScreensReadResponse,
} from '../getScreens';

export const getProxyComponents = (data: { url: string }) => {
  return defaultHttpClient
    .request<ScreensReadResponse>({ method: 'GET', url: `/api/v2/${data.url}` })
    .then(result => result.data)
    .then(atomicRendererDataConverter);
};
